<template>
  <app-base-main parentTable noPadding :baseStyle="{'padding-top': '12px'}">
    <template #filter-group>
      <app-filter-group
          @reset="$gjReset"
          @query="$gjNoticeQuery"
      >
        <gj-country-server-select
            v-model="filter.countryMarketValue"
        ></gj-country-server-select>
        <gj-select
            v-model="filter.status"
            :options="listingStatus"
            placeholder="全部状态"
        ></gj-select>
        <gj-warehouse-select
            :self="false"
            multiple
            v-model="filter.warehouseIds"
            placeholder="全部仓库"
            width="180px"
        >
        </gj-warehouse-select>
        <gj-date-picker
            v-model="filter.date"
            type="month"
            :clearable="false"
        ></gj-date-picker>
        <gj-select-input
            v-model="filter.keyword"
            :options="[
              {id: 'msku', text: 'MSKU'},
              {id: 'asin', text: 'ASIN'},
              {id: 'sku', text: 'SKU'},
              {id: 'name', text: '产品名称'},
          ]"
        >
        </gj-select-input>
        <template #right>
          <gj-tool-group
              log @viewLog="openLog"
              :download="$permission('financialMonthCost:export')"
              download-url="/finance/financialMonthCost/monthCostListExport?type=FBA"
              :download-params="globalParams"
              help
          >
            <template #before>
              <gj-tooltip>
                <template #content>
                  使用说明：<br>
                  1、月度固定成本模式：从成本中心取值，体现在销售订单的支出模块：成本项（采购成本+到库成本）； <br>
                  2、先进先出模式：当订单匹配不到批次成本时，会从成本中心取值，体现在销售订单的支出模块：成本项（采购成本+到库成本）；
                </template>
                <gj-button
                    type="icon"
                    plain
                    class="tool--btn-icon">
                  <i class="iconfont iconxiaoxitishi"></i>
                </gj-button>
              </gj-tooltip>
            </template>
          </gj-tool-group>
        </template>
      </app-filter-group>
    </template>
    <template #operate-group>
      <gj-button v-if="$permission('financialMonthCost:import')" type="primary" @click="importCost">导入</gj-button>
      <gj-button v-if="$permission('financialMonthCost:batchUpdate')" @click="batchEdit(selectedRows)"
                 :disabled="noSelect">批量修改
      </gj-button>
    </template>
    <template #tool-group>
      <div class="tools-tips">
        <div class="tips">
          <span class="gj-icon icon1"></span> <span>未维护</span>
        </div>
        <div class="tips">
          <span class="gj-icon icon2"></span> <span>手动更新</span>
        </div>
        <div class="tips">
          <span class="gj-icon icon3"></span> <span>系统更新</span>
        </div>
      </div>
    </template>
    <template #table>
      <gj-table
          ref="gjTable"
          :imageTag="'新'"
          adaptParent
          :columns="expandColumns"
          :data="data"
          :index="false"
          selection
          :name="moduleName"
          :pagination="pagination"
          :loading="loading"
          :default-sort="{prop: 'slot:updateTime', order: 'descending'}"
          @sort-change="$gjSortChange"
          @page-change="$gjNoticeQuery">
        <template v-slot:imageUrl="{row}">
          <div class="flex" style="position: relative;width: 100%;">
            <gj-image
              :src="row.imageUrl"
              :tag="row.listingStatus === 1 ? '新' : null"
              :tag-color="{ color: '#1F6EEF', bdColor: '#4994FC', bgColor: '#EDF7FF' }">
            </gj-image>
          </div>
        </template>
        <template v-slot:marketIds="{row}">
          <gj-tooltip class="value" :text-line="1" :content="row.marketIds">{{ row.marketIds }}</gj-tooltip>
        </template>
        <template v-slot:msku="{row}">
          <div>
            <div>
              <gj-text maxWidth="85%" :content="row.skuName">{{ row.msku }}</gj-text>
              <span v-copy="row.msku" class="copy-icon gj-cell-display-switch">
                <gj-icon class="el-icon-copy-document"></gj-icon>
              </span>
            </div>
            <gj-link :href="row.asinUrl" target="_blank">{{ row.asin }}</gj-link>
            <span v-if="row.asin" v-copy="row.asin" class="copy-icon gj-cell-display-switch">
                <gj-icon class="el-icon-copy-document"></gj-icon>
            </span>
          </div>
        </template>

        <template v-slot:goodsStatus="{row}">
          <gj-tag type="text" :color="getColor(row.goodsStatus)">{{statusOption[row.goodsStatus] | defaultShow}}</gj-tag>
        </template>
        <template v-slot:sku="{row}">
          <div>
            <gj-tooltip class="value" :text-line="1" :content="row.sku">{{ row.sku | defaultShow }}</gj-tooltip>
            <span v-if="row.sku" v-copy="row.sku" class="copy-icon gj-cell-display-switch">
                <gj-icon class="el-icon-copy-document"></gj-icon>
            </span>
          </div>
        </template>
        <template v-slot:skuName="{row}">
<!--          <gj-tooltip class="value" :text-line="1" :content="row.skuName">{{ row.skuName }}</gj-tooltip>-->
             <gj-text width="90%">{{row.skuName | defaultShow}}</gj-text>
        </template>
        <template v-slot:warehouseName="{row}">
          <gj-tooltip class="value"  :text-line="1" :content="row.warehouseName">
            {{ row.warehouseName }}
          </gj-tooltip>
        </template>
        <template v-slot:purchaseCost="{ row }">
          <template v-if="$permission('financialMonthCost:update')">
            <gj-input
                v-model="row.purchaseCost"
                @change="debounceUpdateCost(row,'purchaseCost')"
                placeholder="采购成本"
                width="100%"
                v-number.toFixed4
                maxlength="13"
            >
              <template #prepend>
                ￥
              </template>
            </gj-input>
          </template>
          <template v-else>
            {{ row.purchaseCost ? '￥' + row.purchaseCost : '-' }}
          </template>
        </template>
        <template v-slot:inventoryCost="{row}">
          <template v-if="$permission('financialMonthCost:update')">
            <gj-input
                v-model="row.inventoryCost"
                @change="debounceUpdateCost(row,'inventoryCost')"
                placeholder="到库成本"
                width="100%"
                v-number.toFixed4
                maxlength="13"
            >
              <template #prepend>
                ￥
              </template>
            </gj-input>
          </template>
          <template v-else>
            {{ row.inventoryCost ? '￥' + row.inventoryCost : '-' }}
          </template>
        </template>
        <template v-slot:lastUpdate="{row}">
          <el-row>
            <el-col :span="19">
              <gj-popover trigger="hover" placement="bottom" width="350px" height="130px">
                <!-- 悬浮展示的内容 -->
                <div class="popover-title">近12月更新:</div>
                <div class="popover-hover">
                  <div class="popover-content" v-if="row['historyStatus2'][0].length>0">
                    <div class="item-year">{{ row['historyStatus2'][0][0].year }}年</div>
                    <div class="flex">
                      <div v-for="(item,i) in row['historyStatus2'][0]" :key="i" class="popover-item">
                        <div :class="{'radius-icon':true,'icon1':item.status === 0,'icon2':item.status === 1,'icon3':item.status === 2}"></div>
                        <div class="radius-str">{{ item.month }}</div>
                      </div>
                    </div>
                  </div>
                  <div class="popover-content" v-if="row['historyStatus2'][1].length>0">
                    <div class="item-year">{{ row['historyStatus2'][1][0].year }}年</div>
                    <div class="flex">
                      <div v-for="(item,i) in row['historyStatus2'][1]" :key="i" class="popover-item">
                        <div :class="{'radius-icon':true,'icon1':item.status === 0,'icon2':item.status === 1,'icon3':item.status === 2}"></div>
                        <div class="radius-str">{{ item.month }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <div slot="reference" style='display:flex'>
                  <span
                      :class="{'radius-icon':true,'icon1':item.status === 0,'icon2':item.status === 1,'icon3':item.status === 2}"
                      v-for="(item,i) in row['historyStatus']" :key="i"></span>
                </div>
              </gj-popover>

            </el-col>
            <el-col :span="5">
              <span class="more" @click="moreHistory(row)">查看更多</span>
            </el-col>
          </el-row>
        </template>
      </gj-table>
    </template>
    <template #base-content>
        <new-user-guide v-if="userGuideState" ref="newUserGuide" @closeModal="closeModal"></new-user-guide>
      </template>
  </app-base-main>
</template>

<script>
import CostCenterImport from './cost-center-import';
import GjLogModal from "../../../../components/modal/gj-log-modal";
import MoreHistory from './more-history'
import costBatchEdit from "./cont-batch-edit"
import {queryMixin, selectionMixin, userGuideMixin} from "../../../../minxins";
import {
  exportCostCenter,
  // UpdateMonthCost,
  getFbaMonthCostPage,
  queryAllCountry,
  batchUpdateFBAMonthCost
} from "../../../../api/finance";
import {convertToFullDate} from "../../../../utils/date.util";
import {isMeaningful, isMeaningless} from "../../../../utils/common";
import {mapGetters} from "vuex";
import {tagColors} from "@/components/tag/tag-colors";
import { listingStatus } from "@/utils/options";
import NewUserGuide from "./components/new-user-guide"

export default {
  name: "cost-center-fba",
  components: { NewUserGuide },
  mixins: [queryMixin, selectionMixin,userGuideMixin],
  computed: {
    ...mapGetters({
      marketOption: 'marketOption'
    }),
    downloadUrl:function (){
      if (isMeaningful(this.filter.countryMarketValue)) {
        return `/finance/financialMonthCost/monthCostListExport?countryCodes=${this.filter.countryMarketValue.countryIds.join(',')}&marketIds=${this.filter.countryMarketValue.marketIds.join(',')}&type=FBA`
      }else {
        return `/finance/financialMonthCost/monthCostListExport?countryCodes=&marketIds=&type=FBA`
      }
    }
  },
  data() {
    return {
      tagColors,
      moduleName: "cost-center-fba",
      filter: {
        countryMarketValue: null,
        status: null,
        warehouseIds: null,
        date: new Date(),
        keyword: {
          key: 'msku',
          value: null,
        },
      },
      expandColumns: [
        {id: 'imageUrl', header: '图片', field: 'slot:imageUrl', minWidth: '70px', default: true, disabled: true},
        {id: 'marketId', header: '店铺/国家', field: 'slot:marketIds', minWidth: '120px', default: true, disabled: true},
        {id: 'msku', header: 'MSKU/ASIN', field: 'slot:msku', minWidth: '180px', default: true, sortable: true, sortBy:'msku'},
        {id: 'goodsStatus', header: '状态', field: 'slot:goodsStatus', minWidth: '45px', default: true, disabled: true},
        {id: 'warehouse', header: '仓库', field: 'slot:warehouseName', minWidth: '150px', default: true},
        {id: 'sku', header: 'SKU', field: 'slot:sku', minWidth: '185px', default: true, sortable: true},
        {id: "skuName", header: "产品名称", field: "slot:skuName", minWidth: "150px", default: true},
        {id: 'purchaseCost', header: '采购成本', field: 'slot:purchaseCost', minWidth: '160px', default: true},
        {id: 'inventoryCost', header: '到库成本', field: 'slot:inventoryCost', minWidth: '160px', default: true},
        {
          id: 'updateUserName',
          header: '更新人',
          field: 'updateUserName',
          minWidth: '110px',
          default: true,
          sortable: true,
          sortBy: 'updateUser'
        },
        {id: 'updateTime', header: '更新时间', field: 'updateTime', minWidth: '155px', default: true, sortable: true},
        {id: 'lastUpdate', header: '近12月更新', field: 'slot:lastUpdate', minWidth: '320px', default: true},
      ],
      statusOption:{
        Inactive:'停售',
        Active:'在售',
        Incomplete:'不完整',
        Delete:'删除',
      },
      listingStatus,
      data: [],
      editDis: true,
      debounceUpdateCost: this._.debounce(this.updateCost, 500),
      notStorage: true,
      countryList:[],
      editDate: null
    }
  },
  created() {
    this.sort.prop = 'updateTime';
    this.tooltipContent = 'a \n 2';
    // 查询用户所有FBA仓的国家
    queryAllCountry().then(res => {
      this.countryList = res || [];
    })
  },
  methods: {
    getColor(val){
      switch (val) {
        case 'Inactive':
          return this.tagColors.gray
        case 'Active':
          return this.tagColors.green
        case 'Incomplete':
          return this.tagColors.gray
        case 'Delete':
          return this.tagColors.red
      }
    },
    $gjQuery() {
      this.loading = true;
      this.editDate = convertToFullDate(this.filter.date, 'yyyy-MM');
      const params = {
        moduleName: "cost-center-fba",
        model: {
          goodsStatus: this.filter.status,
          warehouseIds: this.filter.warehouseIds,
          monthDate: convertToFullDate(this.filter.date, 'yyyy-MM'),
        },
        ...this.querySort,
        ...this.queryPagination,
      };
      if (isMeaningful(this.filter.countryMarketValue)) {
        params.model.marketIds = this.filter.countryMarketValue.marketIds;
        params.model.countryCodes = this.filter.countryMarketValue.countryIds;
      }
      params.model[this.filter.keyword.key] = this.filter.keyword.value;
      this.globalParams = params;
      getFbaMonthCostPage(params)
          .then((data) => {
            data.records.forEach(item => {

              // 店铺/国家
              item.marketIds = item.marketIds.split(',');
              if(item.marketIds.length>0){
                item.marketIds = item.marketIds.map(r => {
                  return this.marketOption.find(m => m.id == r).text
                }).join(',')
              }else {
                item.marketIds = '-'
              }

              //近12月更新 图标组
              item.historyStatus2 = item.historyStatus.reduce((arr, his, i) => {
                let monthDate = his.monthDate.split('-');
                his.year = monthDate[0];
                his.month = monthDate[1];
                if (i === 0) {
                  arr[0].push(his);
                  return arr;
                }
                arr[0][0].year === monthDate[0] ? arr[0].push(his) : arr[1].push(his);
                return arr;
              }, [[], []])
            })
            data.records.forEach(item=>{
              if(!item.purchaseCost && !item.inventoryCost){
                 item.updateTime = null;
              }
            })
            this.data = data.records;
            this.pagination = this.getPagination(data);
          }).complete(() => this.loading = false)
    },
    $gjQueryInitParams() {
      return {
        filter: {
          warehouseIds: null,
          date: new Date(),
          countryMarketValue: null,
          status: null,
          keyword: {
            key: 'msku',
            value: null,
          }
        }
      }
    },
    updateCost(row, key) {
      let value = row[key].split('.')[0]+'';
      if(value.length > 8){
        this.$gjMessage.error('请输入正确的数值，金额不能大于8位，保留4位小数');
        return false;
      }
      const reg = /^[0-9]+(.?[0-9]{1,4})?$/;
      if (isMeaningless(row[key]) || (!isNaN(row[key]) && reg.test(row[key]))) {
        batchUpdateFBAMonthCost([{
          id: row.id,
          purchaseCost: isMeaningful(row['purchaseCost']) ? row['purchaseCost'] : 0,
          inventoryCost: isMeaningful(row['inventoryCost']) ? row['inventoryCost'] : 0,
          warehouseId:row.warehouseId,
          msku:row.msku,
          monthDate: this.editDate
        }])
            .then(() => {
                this.$gjMessage.success('自动保存成功')
                this.userGuideNextStep()
              })
      } else {
        this.$gjMessage.error('请输入正确的数值，保留四位小数');
      }
    },
    moreHistory(row) {
      const modal = this.$gjCreate(MoreHistory, {
        props: {
          formData: row,
          params: {
            keyWord:row.msku,
            type:'msku',
            warehouseId:row.warehouseId
          }
        },
        on: {
          updated: () => {
            this.$gjQuery();
            modal.$gjDestroy()
          },
          cancel() {
            modal.$gjDestroy()
          }
        }
      })
    },
    importCost() {
      const modal = this.$gjCreate(CostCenterImport, {
        props: {
          type: 'MSKU',
          countryList:this.countryList
        },
        on: {
          importFileSuccess: () => {
            this.$gjResetPage();
          }
        }
      })
    },
    openLog() {
      this.$gjCreate(GjLogModal, {
        props: {
          url: '/finance/financialMonthCostLog/page',
          params: {
            model: {
              type: 'FBA'
            }
          },
          columns: [
            {id: 'createDate', header: '操作时间', field: 'createTime', width: '155px'},
            {id: 'opUser', header: '操作用户', field: 'opUser', width: '130px'},
            {
              id: 'op',
              header: '操作分类',
              field: 'option:op',
              options:  [
                {id: 'Add', text: '新增'},
                {id: 'Update', text: '更新'},
                {id: 'Delete', text: '删除'},
                {id: 'Import', text: '导入'},
                {id: 'Export', text: '导出'},
                {id: 'USER_UPDATE', text: '手动维护'},
                {id: 'SYSTEM_UPDATE', text: '系统维护'}
              ],
              width: '120px'
            },
            {id: 'content', header: '操作内容', field: 'content', overflowLine: 2, minWidth: '450px'}
          ],
        }
      })
    },
    batchEdit(rows) {
      let modal = this.$gjCreate(costBatchEdit, {
        props: {
          type: 'msku',
          rows: rows,
          date: this.editDate
        },
        on: {
          updated: () => {
            this.$gjQuery();
            modal.$gjDestroy()
          },
          cancel: () => {
            modal.$gjDestroy()
          }
        },
      });
    },
    clickDownload() {
      const params = {
        model: {
          warehouseIds: this.filter.warehouseIds,
          monthDate: convertToFullDate(this.filter.date, 'yyyy-MM'),
        },
        ...this.queryPagination,
        ...this.querySort,
      };
      params.model[this.filter.keyword.key] = this.filter.keyword.value;
      exportCostCenter(params);
    },

    closeModal() {
        if(this.adAuthModal)  {
          this.isAutoAdAuthModal = true; // 是否为主动销毁
          this.adAuthModal.$gjDestroy();
          this.adAuthModal = null;
        }
    
     },
  }
}
</script>

<style scoped lang="scss">

.el-popover__reference{
  .radius-icon+.radius-icon{
    margin-left: 4px;
  }
}

.tools-tips {
  margin-right: 20px;
  display: flex;
  font-size: 12px;
  color: rgba(0, 0, 0, 0.5);

  .tips {

    .gj-icon {
      display: inline-block;
      width: 9px;
      height: 9px;
      border-radius: 4px;
    }
  }
  .tips+.tips{
    margin-left: 40px;
  }
}

.popover-hover {
  display: flex;

  .popover-content {
    background: #F6F8FB;
    border-radius: 2px;
    padding: 8px 8px 4px;

    .item-year {
      font-size: 12px;
      color: #333333;
      line-height: 18px;
      font-weight: 500;
    }
    .popover-item {
      position: relative;
      padding-top: 5px;
    }
    .popover-item+.popover-item{
      margin-left: 8px;
    }

  }
  .popover-content + .popover-content{
    margin-left: 4px;
  }
}

.radius-icon {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 5px;
}
.radius-str{
  font-size: 12px;
  color: #333333;
  line-height: 18px;
  font-weight: 400;
  text-align: center;
}

.popover-title {
  font-size: 13px;
  font-weight: 600;
  color: #000000;
  margin-bottom: 8px;
}

.icon1 {
  border: 1px solid #999;
  background-color: #E4E5E6;
}

.icon2 {
  border: 1px solid #ED6A0C;
  background-color: #F6BB90;
}

.icon3 {
  border: 1px solid #4994FC;
  background-color: #9CCCFF;

}

.more {
  font-size: 12px;
  color: #1F6EEF;
  margin-left: 5px;
  cursor: pointer;
}

.label {
  color: #666;
  margin-right: 10px;
}

.value {
  color: #333;
}
/deep/.el-dialog .vxe-cell {
  white-space: pre-line !important;
  word-break: break-all !important;
}
.img-tag{
  margin-left: 3px;
}
</style>
